import { render, staticRenderFns } from "./user-roles-component.vue?vue&type=template&id=4336fdc4&scoped=true"
import script from "./user-roles-component.vue?vue&type=script&lang=js"
export * from "./user-roles-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4336fdc4",
  null
  
)

export default component.exports